/* eslint-disable */
import { useState, useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";
import Select from "react-select";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  getData,
  postData,
  uploadMultipleFile,
  uploadSingleFile,
} from "utils/Gateway";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const GenerateDebatePopup = ({
  selectedFaqId = null,
  setSelectedFaqId = () => {},
  afterPopupClose = () => {},
}) => {
  const token = localStorage.getItem("token");

  const { t } = useTranslation();

  const spinCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const [categoryList, setcategoryList] = useState([]);
  const [tagList, setTagList] = useState([]);

  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  // initial state for uploaded multiple files
  const [media, setMedia] = useState([]);
  //initial state for uploaded image id
  const [fileIds, setFileIds] = useState([]);
  const [tagValue, settagValue] = useState(null);
  const [selectedTags, setselectedTags] = useState([]);
  const [categoryValue, setcategoryValue] = useState(null);
  const [selectedCategories, setselectedCategories] = useState([]);

  const [isUploading, setIsUploading] = useState(false);
  const [isSaving, setisSaving] = useState(false);

  const editor = useRef(null);

  const detailsEditorCustomConfig = {
    readonly: false,
    toolbarSticky: false,
    placeholder: "",
    height: "315",
    statusbar: false,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestURL =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestURL, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
    ],
  };

  const detailsEditorConfig = useMemo(() => detailsEditorCustomConfig, []);

  //function for get all category
  const getAllCategoryList = async () => {
    try {
      const parentSlug = "CAT_ACTIVITY";
      const response = await getAllCategories(parentSlug);
      if (response) {
        setcategoryList(response);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

      const response = await getData(requestURL);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // function for multiple file upload
  const multipleFileUploadHandler = async (targetFiles) => {
    let filesLength = targetFiles.length;

    let proceed = false;

    if (filesLength > 0) {
      for (let i = 0; i < filesLength; i++) {
        let f = targetFiles[i];

        if (f.size <= 12500000) {
          proceed = true;
        } else {
          proceed = false;
        }
      }

      if (proceed) {
        try {
          setIsUploading(true);
          let requestURL =
            url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

          const response = await uploadMultipleFile(requestURL, targetFiles);

          console.log(response);

          setIsUploading(false);

          resetFile();

          if (response.status) {
            const uploadedFileValues = response.data.map(
              ({ name, path, _id, ...other }) => ({
                name,
                path: url.SERVER_URL + path,
                _id,
              })
            );

            const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

            //check old file exist or not if exist then new file will concat with old file
            if (media.length === 0) {
              setMedia(uploadedFileValues);
              setFileIds(fileIds);
            } else {
              setMedia([...media, ...uploadedFileValues]);
              setFileIds([...fileIds, ...fileIds]);
            }
          }
        } catch (error) {}
      }
    } else {
      return;
    }
  };

  // function for clear file value
  const resetFile = () => {
    const file = document.getElementById("forum_attachFiles");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  const deletFileHanlder = (index) => {
    const updatedIds = [...fileIds];
    const updatedmedia = [...media];
    const fileMediaindex = updatedIds.indexOf(index);
    const fileIdIndex = updatedmedia.indexOf(index);
    updatedIds.splice(fileIdIndex, 1);
    updatedmedia.splice(fileMediaindex, 1);
    setFileIds(updatedIds);
    setMedia(updatedmedia);
  };

  //get faq details
  const getFaqDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_FAQ_DETAILS +
        `/${selectedFaqId}?token=${token}`;

      const response = await getData(requestURL);

      if (response.status) {
        const data = response.data;

        settitle(data.question);
        setdetails(data.answer);
        setFileIds(data.uploadids);
        setMedia(
          data.uploadedfiles.map(({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          }))
        );
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //generate debate function
  const generateDebateHandler = async (e) => {
    try {
      setisSaving(true);

      let apiData = {
        title,
        description: details,
        uploads: fileIds,
        faqid: selectedFaqId,
      };

      let requestURL =
        url.API_BASE_URL + url.API_GENERATE_DEBATE + `?token=${token}`;

      const response = await postData(requestURL, apiData);

      setisSaving(false);

      console.log(response);

      if (response.status) {
        // close the popup
        let offCanvasPopup = document.querySelector("#offcanvasForum");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        resetHandler();
        afterPopupClose();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //reset function
  const resetHandler = () => {
    setcategoryList([]);
    setTagList([]);
    settitle("");
    setdetails("");
    setMedia([]);
    setFileIds([]);
    settagValue(null);
    setcategoryValue(null);
    setselectedCategories([]);
    setselectedTags([]);
    resetFile();
    setSelectedFaqId(null);
  };

  useEffect(() => {
    if (selectedFaqId) {
      getFaqDetails();
      getAllCategoryList();
      getAllTags();
    }
  }, [selectedFaqId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasForum"
      aria-labelledby="offcanvasForumLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              forum
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasForumLabel"
            >
              Generate a Debate in Forum
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Create a new debate in the forum")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="question"
                className="d-block fs-sm fw-semibold mb-2 text-dark"
              >
                Post Your Reply
              </label>
              <input
                type="text"
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder="Question"
                value={title}
                onChange={(e) => settitle(e.target.value)}
              />
            </div>

            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="question"
                className="d-block fs-sm fw-semibold mb-2 text-dark"
              >
                Details
              </label>
              <JoditEditor
                ref={editor}
                value={details}
                config={detailsEditorConfig}
                onBlur={(newContent) => {
                  setdetails(newContent);
                }}
                onChange={(newContent, event) => {}}
              />
            </div>

            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="question"
                className="d-block fs-sm fw-semibold mb-2 text-dark"
              >
                Attach File
              </label>

              <FileUploadField
                label={t("Upload Documents")}
                accept="doc mp4 pdf"
                onUpload={multipleFileUploadHandler}
                files={media}
                onRemove={deletFileHanlder}
                loading={isUploading}
                fileType="document"
              />
            </div>

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={generateDebateHandler}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    <span>
                      {t("Confirm")} & {t("Publish Debate")}
                    </span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GenerateDebatePopup;
